export const ABOUT_ME = 'about-me';
export const PROJECTS = 'projects';
export const CONTACT = 'contact';
